var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeCancelationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4278 6.85302L4.7841 8.20932L7.33274 5.55241",
    stroke: "#008F4B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4278 6.85302L4.7841 8.20932L7.33274 5.55241",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40108 0L2.70024 1.70084L4.40108 3.40168L4.96601 2.83676L4.23062 2.1L5.34931 2.1003C7.86414 2.1003 9.8997 4.13586 9.8997 6.65069C9.8997 9.16552 7.86414 11.2011 5.34931 11.2011C2.88688 11.2011 0.883947 9.24945 0.801561 6.80723L0.798924 6.65069H1.90735e-06C1.90735e-06 9.60675 2.39325 12 5.34931 12C8.30537 12 10.6986 9.60675 10.6986 6.65069C10.6986 3.7504 8.39483 1.39189 5.51602 1.30392L5.34931 1.30138L4.22929 1.30133L4.96601 0.564924L4.40108 0Z",
    fill: "#008F4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40108 0L2.70024 1.70084L4.40108 3.40168L4.96601 2.83676L4.23062 2.1L5.34931 2.1003C7.86414 2.1003 9.8997 4.13586 9.8997 6.65069C9.8997 9.16552 7.86414 11.2011 5.34931 11.2011C2.88688 11.2011 0.883947 9.24945 0.801561 6.80723L0.798924 6.65069H1.90735e-06C1.90735e-06 9.60675 2.39325 12 5.34931 12C8.30537 12 10.6986 9.60675 10.6986 6.65069C10.6986 3.7504 8.39483 1.39189 5.51602 1.30392L5.34931 1.30138L4.22929 1.30133L4.96601 0.564924L4.40108 0Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeCancelationIcon);
export default __webpack_public_path__ + "static/media/free_cancelation_icon.f5513f14567462e2a6ce6169c3a3955d.svg";
export { ForwardRef as ReactComponent };